import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ExpandCollapseButton from "./ExpandCollapseButton";
import { useTranslation } from "react-i18next";
import { useProfile } from "./ProfileProvider";
import { useRouteMatch } from "./useRouteMatch";
import tailwindClassnames from "./TailwindClassnames";

interface SideMenuProps {
  // You can define props here if you have any, for example, active page
}

const SideMenu: React.FC<SideMenuProps> = () => {
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const { profile, profileLoading } = useProfile();
  const [permissionsLoaded, setPermissionsLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!profileLoading && profile) {
      setPermissionsLoaded(true);
    }
  }, [profileLoading, profile]);

  const toggleMenu = () => {
    setIsExpanded(!isExpanded);
  };

  const { t } = useTranslation();
  const matchUsers = useRouteMatch([
    "/users",
    "/users/add",
    "/users/accountCreation",
  ]);
  const matchOrganizations = useRouteMatch([
    "/organizations",
    "/addOrganization",
  ]);
  const matchProjects = useRouteMatch(["/", "/projects", "/addProject"]);
  const getNavLinkClass = (
    isActive: boolean,
    isActiveCondition: boolean = false,
  ) =>
    isActive || isActiveCondition
      ? tailwindClassnames.sideNavItemActive
      : tailwindClassnames.sideNavItem;

  return !permissionsLoaded || profile === null || !profile.is_active ? (
    <div className="w-48 border-r border-off-white-dark dark:border-storm-blue-border h-screen"></div>
  ) : (
    <div
      className={`side-nav ${
        isExpanded ? "w-48 px-2 " : "w-8"
      } bg-primary-off-white dark:bg-storm-blue-dark border-r border-off-white-dark dark:border-storm-blue-border h-screen relative transition duration-300`}
    >
      <ul className={isExpanded ? "visible text-left mt-7" : "hidden"}>
        <li className="w-full">
          <NavLink
            to="/organizations"
            className={({ isActive }) =>
              getNavLinkClass(isActive, matchOrganizations)
            }
          >
            {t("Organizations")}
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) =>
              getNavLinkClass(isActive, matchProjects)
            }
          >
            {t("Projects")}
          </NavLink>
        </li>
        {profile.is_admin && (
          <li>
            <NavLink
              to="/users"
              className={({ isActive }) =>
                getNavLinkClass(isActive, matchUsers)
              }
            >
              {t("Users")}
            </NavLink>
          </li>
        )}
      </ul>
      <ExpandCollapseButton onClick={toggleMenu} isExpanded={isExpanded} />
    </div>
  );
};

export default SideMenu;
